import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IS_APP_CODEAC, VERSION } from '../../../constants/env';
const getImagePath = (name, pixelRatio = 1, extension = 'jpg') => {
    const postfix = pixelRatio !== 1 ? `@${pixelRatio}x` : '';
    return `/images/${name}${postfix}.${extension}?v${VERSION} ${pixelRatio}x`;
};
const getImagePathSet = (name, pixelRatios = [1, 2], extension = 'jpg') => {
    return pixelRatios.map(pixelRatio => {
        return getImagePath(name, pixelRatio, extension);
    }).join(', ');
};
export const MainPicture = ({ isGha, isAppCodeac = IS_APP_CODEAC }) => {
    const { t } = useTranslation();
    const title = _jsx("h2", { className: 'content__title', "data-testid": 'title', children: t('startJourney', { siteName: t('siteName') }) });
    if (isAppCodeac) {
        return _jsxs(_Fragment, { children: [title, _jsxs("p", { "data-testid": 'images', children: [_jsx("img", { className: 'img-fluid mt-4 mb-4 d-none d-lg-inline-block', height: '256', width: '886', alt: t(isGha ? 'installApp' : 'registerWebhook'), src: getImagePath('commits-trial-graph'), srcSet: getImagePathSet('commits-trial-graph') }), _jsx("img", { className: 'img-fluid mt-4 mb-4 d-lg-none', height: '198', width: '395', alt: t(isGha ? 'installApp' : 'registerWebhook'), src: getImagePath('trial-graph'), srcSet: getImagePathSet('trial-graph') })] })] });
    }
    return _jsxs(_Fragment, { children: [_jsx("span", { className: 'content__picture', "data-testid": 'icon', children: "\u00A0" }), title] });
};
